import { createContext, useContext } from "react";

interface IStackedNavigationContext {
  stack: string[];
  params: Record<string, unknown>;
  open: (id: string, params?: Record<string, unknown>) => void;
  goBack: (count?: number) => void;
  clear: () => void;
}

export const StackedNavigationContext = createContext<IStackedNavigationContext | undefined>(undefined);

const throwProviderError = (methodName: string) => {
  throw new Error(`Cannot call ${methodName}() - component is not wrapped in StackedNavigationProvider`);
};

export const useStackedNavigationContext = (): IStackedNavigationContext => {
  const context = useContext(StackedNavigationContext);

  // Return safe defaults for read-only properties, but throw errors for methods
  if (context === undefined) {
    return {
      stack: [],
      params: {},
      open: () => throwProviderError("open"),
      goBack: () => throwProviderError("goBack"),
      clear: () => throwProviderError("clear"),
    };
  }

  return context;
};
